import {tenantFeatureEnabled} from '../../../tenant/tenantState'

/**
 * Whether the supplier uploads their own invoice against a monthly settlement.
 *
 * On Dumyah they do: the settlement waits on `pending_partner_invoice` until the
 * upload moves it into accounting's queue. Tenants whose suppliers issue no
 * invoices disable `supplier_invoice_required`; their settlements are generated
 * straight into that queue, so the upload button here has nothing to do — and
 * the API refuses the upload anyway (403).
 *
 * Fail-open (`tenantFeatureEnabled` defaults true) keeps the button for Dumyah
 * and for any tenant whose config predates the flag.
 *
 * Kept in its own tiny module so it is unit-testable without pulling the row's
 * intl / api / modal import graph into the test.
 */
export function invoiceUploadVisible(): boolean {
  return tenantFeatureEnabled('supplier_invoice_required')
}
